<template>
    <div class="uilanguages-page">
        <div class="page-head">
            <div class="left">
                <h1>Manage user interface languages</h1>
            </div>
        </div>
        <UILanguagesList ref="uiLanguagesList"> </UILanguagesList>
    </div>
</template>

<script>
import UILanguagesList from '@/components/UILanguages/UILanguagesList'
    export default {
        name: "UILanguages",
        components: {
            UILanguagesList
        },

        methods: {

        },
        mounted() {}
    };
</script>

<style scoped></style>
